import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import ToggleSwitch from './ToggleSwitch';

export default function GlobalFlags({ onError }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState('');

  const load = useCallback(() => {
    setLoading(true);

    return axios
      .get('/api/settings')
      .then((res) => setItems(res.data?.items || []))
      .catch((err) => onError?.(err))
      .finally(() => setLoading(false));
  }, [onError]);

  useEffect(() => {
    load();
  }, [load]);

  const toggle = (key, value) => {
    setSaving(key);

    axios
      .put(`/api/settings/${encodeURIComponent(key)}`, { value })
      .then((res) => {
        setItems((current) =>
          current.map((item) => (item.key === key ? { ...item, value: res.data?.value } : item))
        );
      })
      .catch((err) => onError?.(err))
      .finally(() => setSaving(''));
  };

  return (
    <div className="app-editor-card compact-card">
      <div className="app-editor-card-body compact-card-body">
        <div className="stats-section-title">Загальні перемикачі</div>
        <div className="stats-section-subtitle">Діють одразу на всі додатки</div>

        {loading ? (
          <div className="settings-empty">Завантаження…</div>
        ) : (
          <div className="gf-list">
            {items.map((item) => (
              <div className="gf-item" key={item.key}>
                <div className="gf-item-main">
                  <ToggleSwitch
                    label={item.label}
                    value={Boolean(item.value)}
                    onChange={(next) => toggle(item.key, next)}
                  />
                  {item.hint ? <div className="gf-item-hint">{item.hint}</div> : null}
                </div>
                {saving === item.key ? <span className="gf-item-saving">збереження…</span> : null}
              </div>
            ))}

            {!items.length ? <div className="settings-empty">Перемикачів немає</div> : null}
          </div>
        )}
      </div>
    </div>
  );
}
